/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Input_AriaInputs */

const en_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the catalog`)
};

const zh_hans1_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索目录`)
};

const pt_br2_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar no catálogo`)
};

const es_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar en el catálogo`)
};

const fr_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher dans le catalogue`)
};

const de_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katalog durchsuchen`)
};

const ru_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искать в каталоге`)
};

const it_search_input_aria = /** @type {(inputs: Search_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nel catalogo`)
};

/**
* | output |
* | --- |
* | "Search the catalog" |
*
* @param {Search_Input_AriaInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_input_aria = /** @type {((inputs?: Search_Input_AriaInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Input_AriaInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_input_aria(inputs)
	if (locale === "pt-BR") return pt_br2_search_input_aria(inputs)
	if (locale === "es") return es_search_input_aria(inputs)
	if (locale === "fr") return fr_search_input_aria(inputs)
	if (locale === "de") return de_search_input_aria(inputs)
	if (locale === "ru") return ru_search_input_aria(inputs)
	if (locale === "it") return it_search_input_aria(inputs)
	return en_search_input_aria(inputs)
});